import ObjectModel from "../prototypes/ObjectModel";
import _ from "underscore";
import { app } from "./AppModel";
import { vsprintf } from "sprintf-js";
// import SidedishCollection from "./SidedishCollection";
import ProductModel from "./ProductModel";
import SidedishCollection from "./SidedishCollection";
import ProductCollection from "@src/backbone/model/ProductCollection";
import { ICrossSellingChildProduct } from "@src/interface/Product";
import { GATSBY_CONF_MEIJI_COMPAT_VERSION } from "@src/utils/constants";
import { IProductModifier } from "@src/backbone/model/StoreModel";

export interface SidedishAttributes extends Backbone.ObjectHash {
  auto?: "0" | "1";
  button_cancel?: string;
  button_ok: string;
  compo_groupe?: string | "B1" | "F1";
  description?: string;
  description_partner?: string;
  display_free?: boolean;
  display_plus?: true;
  display_size?: 0 | 1 | 2;
  error_description?: string;
  /** @deprecated */
  evening: boolean;
  id_category: string;
  id_cross_selling: string;
  id_parent: string;
  id_product_auto?: string;
  id_product_default?: string[];
  id_product_immutable?: string[];
  id_product_max?: string[];
  is_attached?: boolean;
  is_free?: boolean;
  is_pack?: boolean;
  is_required?: boolean;
  linked_to_crosselling?: string;
  /** @deprecated */
  midday?: boolean;
  mode?: string | "1";
  multiple_by_product?: boolean;
  pos_custom_box?: number[];
  quantity_max?: number;
  quantity_min?: number;
  selection?: SidedishSelection[];
  subtitle?: string;
  template?: string;
  title?: string;
  title_partner: string;
  url?: string;
  products?: ICrossSellingChildProduct[];
  visibility?: {
    day: 0 | 1 | 2 | 3 | 4 | 5 | 6;
    time_deb: string;
    time_end: string;
  }[];
}

export interface SidedishSelection {
  id: string;
  id_product_parent: string;
  p: ProductModel;
  quantity: number;
  default: number;
  immutable: number;
  positions: any[];
  invalid?: boolean;
}

type ICreateSelection = (
  id_product: any,
  id_product_parent: any,
  qty: number,
  defaultQty: number,
  immutableQty: number,
  shiftPosition: () => any
) => SidedishSelection;

const CUSTOM_BOX_42_LOCATIONS = _([
  { id: "A", type: "rolls", o: "h", x: 248, y: 200, z: 6 },
  { id: "B", type: "rolls", o: "h", x: 552, y: 200, z: 7 },
  { id: "C", type: "rolls", o: "v", x: 400, y: 400, z: 1 },
  { id: "D", type: "rolls", o: "h", x: 248, y: 600, z: 8 },
  { id: "E", type: "rolls", o: "h", x: 552, y: 600, z: 9 },
  { id: "F", type: "rolls-div", o: "v", x: 178, x_alt: 622, y: 400, z: 5 },
  { id: "G", type: "sushis-div", o: "v", x: 400, y: 160, y_alt: 640, z: 4 },
  { id: "H", type: "sushis", o: "v", x: 268, y: 400, z: 2 },
  { id: "I", type: "sushis", o: "v", x: 532, y: 400, z: 3 },
]);

//
// Model Sidedish
//

const createSelectionItem: ICreateSelection = (
  id_product: any,
  id_product_parent: any,
  qty: number,
  defaultQty: number,
  immutableQty: number,
  shiftPosition: { (): any; (): any }
) => {
  const positions = [],
    product = app.getProduct(id_product) || new ProductModel({ id_product });
  let invalid = false;
  if (product && !product.isBuyableInContext()) {
    // si le produit n'est pas disponible, on affecte pas de quantité
    if (immutableQty) invalid = true;
    qty = defaultQty = immutableQty = 0;
  }

  for (var i = 0; i < qty; i++) positions.push(shiftPosition());

  return {
    id: id_product,
    id_product_parent: id_product_parent,
    p: product,
    quantity: qty,
    default: defaultQty,
    immutable: immutableQty,
    positions: positions,
    invalid: invalid,
  };
};

class SidedishModel extends ObjectModel<SidedishAttributes> {
  template: any;

  name = "SidedishModel";
  idAttribute = "id_cross_selling";

  static createSelectionItem: ICreateSelection;
  _productCollection: ProductCollection | undefined;

  id_parent: string | undefined;
  midday: boolean = false;
  evening: boolean = false;
  id_category: string = "";
  id_product_default: any;
  id_product_immutable: string[] = [];
  pos_custom_box: any[] = [];
  id_cross_selling: string = "";
  quantity: any;
  immutable: any;
  p!: ProductModel;
  default: number = 0;
  positions: any[] = [];
  selection: any[] | undefined;

  defaults() {
    return {
      selection: [],
    };
  }
  initialize(attributes?: any, options?: any): void {
    const model = this;
    // ObjectModel constructor heritage
    super.initialize.apply(model, [attributes, options]);
    //
    if (!model.get(model.idAttribute)) {
      model.attributes[model.idAttribute] = model.get("id");
    }
  }
  getId() {
    return this.get(this.idAttribute);
  }
  getDisplaySize() {
    return this.get("display_size") || 0;
  }
  getChildren() {
    return (this.collection as unknown as SidedishCollection)?.filteredChild(
      this.id.toString()
    );
  }
  // catégorie produit associée
  getCategory() {
    return app.getCategory(this.get("id_category"));
  }
  getCategoryName() {
    var category = this.getCategory();
    return category ? category.getName() : " - ";
  }
  getTitle() {
    return this.get("title") || this.getCategoryName() || "";
  }
  formatTitle() {
    // var model = this,
    //   title = model.getTitle(),
    //   url = model.get("url");
    // if (url) {
    //   title = '<a href="' + url + '" target="_blank">' + title + "</a>";
    // }
    return this.getTitle();
  }
  getCategoryProducts() {
    const category = this.getCategory();
    return category?.getProducts(true);
  }
  getProducts() {
    const model = this;
    const _products = model.get("products");
    let _productCollection = model._productCollection;
    if (!_products) {
      // legacy
      _productCollection = model.getCategoryProducts();
    } else {
      _productCollection = app
        .getProducts()
        .getProductsByIds(
          _products?.map(({ id_product }) => id_product) || [],
          true
        );
    }
    model._productCollection = _productCollection;
    return _productCollection;
  }
  getMinimum() {
    return this.get("quantity_min") || 0;
  }
  getMaximum() {
    return this.get("quantity_max") || Infinity;
  }
  getMaximumProduct(id_product: string) {
    let max = 0;
    if (!GATSBY_CONF_MEIJI_COMPAT_VERSION) {
      max = (this.get("id_product_max") || []).reduce((memo, id) => {
        return memo + (id === id_product ? 1 : 0);
      }, 0);
    } else {
      const p = this.get("products")?.find((p) => p.id_product === id_product);
      max = parseInt(
        `${
          this.get("products")?.find((p) => p.id_product === id_product)
            ?.quantity_max || 0
        }`
      );
      max && console.log(p, "max", max);
    }
    return max > 0 ? max : Infinity;
  }
  getProduct(id_product: any) {
    // alias
    return app.getProduct(id_product);
  }
  getIsMultipleByProduct() {
    return !!this.get("multiple_by_product") && this.getMaximum() > 1;
  }
  getSelection(): SidedishSelection[] {
    return this.get("selection") || [];
  }
  getSimplifiedSelection() {
    return _(
      this.getSelection().filter(function (item: any) {
        return item.quantity > 0;
      })
    ).map(function (item) {
      return {
        id: item.id,
        quantity: item.quantity,
      };
    });
  }
  getSelectionQuantity(id_product?: any, immutable?: boolean) {
    // permet d'obtenir la quantité totale, ou immutable d'un produit de la selection,
    // ou de l'ensemble de la selection.
    return (
      this.getSelection()?.reduce((acc, s) => {
        if (!id_product || s.id === id_product) {
          acc += immutable ? s.immutable : s.quantity;
        }
        return acc;
      }, 0) || 0
    );
  }
  getSelectionPrice() {
    const selection = this.getSelection();
    const id_cross_selling = this.id;
    let price = 0;
    if (!!GATSBY_CONF_MEIJI_COMPAT_VERSION) {
      selection?.forEach(function (s) {
        const { quantity = 0, id, id_product_parent } = s;
        const childProductStore = app
          .getProduct(id_product_parent)
          ?.getProductStore()
          ?.sidedishes?.find((s) => s.id_cross_selling === id_cross_selling)
          ?.products?.find((p) => p.id_product === id);
        const childProductPrice = childProductStore?.price || 0;
        price += quantity * childProductPrice;
      });
    } else if (!this.isFree()) {
      selection?.forEach(function (s) {
        const product = s.p,
          qty = s.quantity;
        if (product && qty > 0) {
          price += qty * product.getPrice("ttc", true);
        }
      });
    }
    return price;
  }
  getSelectionCartProducts() {
    return app
      .getProducts()
      .getProductsByIds(this.getSelection().map((e) => e.id));
  }
  isStockout() {
    // retourne true si un des produits de la selection est en rupture de stock
    var isStockout = false;
    this.getSelectionCartProducts().each(function (product) {
      isStockout = isStockout || product.isStockout();
    });
    return isStockout;
  }
  validateSelection() {
    const model = this,
      required = model.isRequired(),
      children = model.getChildren(),
      max = model.getQuantityMax(),
      min = model.getQuantityMin();
    let quantity = 0;
    let validate = !required;
    if (children.size()) {
      // si il y a des enfants, on vérifie la selection des enfants
      validate = true;
      children.each(function (sidedishChild) {
        validate = validate && sidedishChild.validateSelection();
      });
    } else if (required || min > 0) {
      // sinon, si c'est requis
      quantity = model.getSelectionQuantity();
      validate = quantity >= (min || 1) && quantity <= max;
    }
    return !!validate;
  }
  changeSelection(
    add: boolean | number,
    id_product: string,
    id_product_parent: string
  ) {
    const model = this,
      currentQuantity = model.getSelectionQuantity(id_product),
      newQuantity =
        typeof add === "boolean" ? currentQuantity + (add ? 1 : -1) : add;
    return model.updateSelection(newQuantity, id_product, id_product_parent);
  }
  updateSelection(
    quantity: number,
    id_product: string,
    id_product_parent: string
  ) {
    var model = this,
      selection = model.getSelection(),
      currentSelection: SidedishSelection,
      allPositions = model.get("pos_custom_box") || [],
      filledPositions = _.flatten(_(selection).pluck("positions")),
      availablePositions = _.difference(allPositions, filledPositions);

    const findEl = _(selection).findWhere({ id: id_product });
    let diffQty = quantity - (!!findEl ? findEl.quantity : 0);
    let add = diffQty > 0;

    if (!findEl) {
      currentSelection = {
        id: id_product,
        id_product_parent,
        quantity: 0,
        default: 0,
        immutable: 0,
        p: app.getProduct(id_product) || new ProductModel({ id_product }),
        positions: [],
      };
      selection.push(currentSelection);
    } else {
      currentSelection = findEl;
    }

    var positions = currentSelection.positions;
    for (var i = 0; i < Math.abs(diffQty); i++) {
      if (!add) {
        positions.pop();
      } else {
        positions.push(availablePositions[i] || "*");
      }
    }
    currentSelection.quantity = quantity;
    return currentSelection;
  }
  // quantité maximale
  getQuantityMax() {
    return this.get("quantity_max") || Infinity;
  }
  getQuantityMin() {
    return this.get("quantity_min") || 0;
  }
  isRequired() {
    return (this.get("quantity_min") || 0) > 0;
  }
  isFreeDisplay() {
    return this.get("display_free") === true;
  }
  isPlusDisplay() {
    return this.get("display_plus") === true;
  }
  isFree() {
    return this.get("is_free") === true;
  }
  isAttached() {
    return this.get("is_attached") === true;
  }
}

SidedishModel.prototype.name = "SidedishModel";
SidedishModel.prototype.idAttribute = "id_cross_selling";

SidedishModel.createSelectionItem = createSelectionItem;

export default SidedishModel;
